import { Injectable } from "@angular/core";
import {
  Device,
  Invitation,
  InvitationUrlActionDto,
  InvitationEntryType,
  InvitationFilter,
} from "./invitation.model";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Guest } from "./guest/guest.model";
import { Observable, Subject } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "src/environments/environment";
import { CustomSocket } from "src/app/_services/custom-socket.service";
import { GetInvitationsQuery } from "src/app/_models/invitations-request.model";
import { Utils } from "src/app/_helpers/utils";

const url = environment.api;

@Injectable({
  providedIn: "root",
})
export class InvitationService {
  invitation: Invitation = new Invitation();
  invitationCount: number;
  entriesCount: number;
  devices: Device[] = [];
  filterDetails: InvitationFilter = {
    ...new InvitationFilter(),
    showAllInvitations: false,
    date: new Date().setHours(0, 0, 0, 0),
    dateStart: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 0),
    dateEnd: null,
  };

  filterDateCriteria = [
    {
      id: 'future',
      translationKey: 'MENU.MY_INVITATIONS_CURRENT',
      name: null
    },
    {
      id: 'all',
      translationKey: 'ALL',
      name: null
    },
    {
      id: 'range',
      translationKey: 'INVITATION.DATE_RANGE',
      name: null
    }
  ];

  currentDateCriterion = this.filterDateCriteria[0];

  filterDetailsSubject: Subject<any> = new Subject<any>();
  filterDetailsShowLoader: boolean;

  reloadFilter(e=null) {
    this.filterDetailsSubject.next(e);
  }

  constructor(
    private http: HttpClient,
    private socket: CustomSocket,
    private translateService: TranslateService
  ) { }

  createInvitation() {
    return this.http.post(url + "invitation", this.invitation);
  }

  deleteInvitation(id: number) {
    return this.http.delete(url + "invitation/" + id);
  }

  getInvitations(getInvitationsQuery: GetInvitationsQuery) {
    return this.http.get<Invitation[]>(url + "invitation", { params: Utils.httpParams(getInvitationsQuery) });
  }

  getInvitation(invitationId: string) {
    return this.http.get<Invitation>(url + "invitation/" + invitationId);
  }

  async getInvitationSync(invitationId: string) {
    return await this.http
      .get<Invitation>(url + "invitation/" + invitationId)
      .toPromise();
  }

  addGuest(newGuest: Guest) {
    this.invitation.invitationGuests.push(newGuest);
  }

  editGuest(editedGuest: Guest) {
    this.invitation.invitationGuests.splice(editedGuest.index, 1, editedGuest);
  }

  invitationGuestAssingCard(invitationGuestId: string, cardNumber: string) {
    return this.http.post(url + "invitation-guest/" + invitationGuestId, {
      accessCard: cardNumber,
    });
  }

  invitationEntry(invitationGuestId: number, type: number) {
    return this.http.post(url + "entry/guest", {
      type: type,
      idInvitationGuest: invitationGuestId,
    });
  }

  getInvIdByQrcodeResponse(qrcode) {
    return this.http.get(
      `${url}invitation-qrcode?qrcode=${encodeURI(qrcode)}`,
      {
        observe: "response",
      }
    );
  }

  getInvtationPublic(qrcode: string) {
    return this.http.get(url + "invitation-public/activation/" + qrcode);
  }

  confimInvitationPublic(invtationUrlAction: InvitationUrlActionDto) {
    return this.http.put(
      url + "invitation-public/activation/",
      invtationUrlAction
    );
  }

  getGuests() {
    return this.http.get(url + "guest");
  }

  getInvitationEntries(
    params: {
      idCompany?: number,
      dateGretherThan?,
      dateLessThan?,
      idDevice?,
      type?: InvitationEntryType
    }
  ) {

    params.type = InvitationEntryType.Entry;



    return this.http.get(url + "entry", { params: Utils.httpParams(params) });
  }

  subscribeNotification(): Observable<{ action: string }> {
    return this.socket.fromEvent<{ action: string }>("notification");
  }

  getDevices(type?: number, reload: boolean = false) {
    let httpParams = new HttpParams();

    if (type) {
      httpParams = httpParams.set("type", type.toString());
    }
    if (this.devices.length === 0 || reload) {
      return this.http
        .get(url + "device/filter", { params: httpParams })
        .toPromise()
        .then((devices: Device[]) => {
          this.devices = devices;

          this.devices.forEach((device, i) => {
            if (device.description == "") {
              device.description = this.translateService.instant(
                "NAME_MISSING"
              );
            }
          });
        });
    }
  }
}
